import { toRefs, computed } from 'vue';
import tinycolor from 'tinycolor2';
import CloseIcon from '../../icons/component-lib.esm7.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { useGroupItem } from '../../compositions/component-lib.esm18.js';
import { getThemeColor, getTextColor } from '../../styles/theme/component-lib.esm.js';

//
var script = {
  components: {
    CloseIcon
  },
  props: {
    component: {
      type: String,
      default: 'span'
    },
    color: {
      type: String,
      default: 'gray200'
    },
    selectedColor: {
      type: String,
      default: 'primary'
    },
    value: [String, Number, Boolean],
    selected: Boolean,
    close: Boolean,
    disabled: Boolean,
    selectable: Boolean,
    // Use standard border radius for the chip
    label: Boolean,
    variant: {
      type: String,
      default: null,
      validator: value => {
        return ['crossed'].includes(value);
      }
    },
    size: {
      type: String,
      default: '.85rem'
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value
    } = toRefs(props);
    const theme = useTheme();
    const {
      isInGroup,
      onToggle,
      isSelected: isItemSelected
    } = useGroupItem(value, 'chip-group');
    const isSelected = computed(() => {
      return isItemSelected.value || props.selected;
    });
    const classes = computed(() => {
      return {
        'v-chip--disabled': props.disabled,
        'v-chip--selected': isSelected.value,
        'v-chip--selectable': props.selectable,
        'v-chip--label': props.label,
        [`v-chip--${props.variant}`]: props.variant
      };
    });
    const styles = computed(() => {
      const bgColor = tinycolor(getThemeColor(props.color, theme.value));
      const selectedAttrs = {};
      if (props.selectable) {
        const selectedBgColor = tinycolor(getThemeColor(props.selectedColor, theme.value));
        const activeColor = tinycolor(getThemeColor(props.color, theme.value));
        selectedAttrs['--c-color-active'] = bgColor.isDark() ? activeColor.lighten(5).toRgbString() : activeColor.darken(5).toRgbString();
        selectedAttrs['--c-color-selected'] = selectedBgColor.toRgbString();
        selectedAttrs['--c-color-selected-text'] = getTextColor(props.selectedColor, theme.value);
        selectedAttrs['--c-color-selected-active'] = selectedBgColor.isDark() ? selectedBgColor.lighten(5).toRgbString() : selectedBgColor.darken(5).toRgbString();
      }
      return {
        '--c-font-size': props.size,
        '--c-color': bgColor.toRgbString(),
        '--c-text-color': getTextColor(props.color, theme.value),
        ...selectedAttrs
      };
    });
    const attributes = computed(() => {
      return {
        disabled: props.disabled,
        role: props.selectable ? 'button' : '',
        'aria-pressed': isSelected.value.toString(),
        tabindex: props.selectable && !props.disabled ? 0 : null
      };
    });
    function handleClick(e) {
      if (props.disabled) return;
      emit('click', e);
      if (isInGroup) onToggle(value.value);
    }
    return {
      isSelected,
      classes,
      styles,
      handleClick,
      attributes
    };
  }
};
export { script as default };